export class AssertIdRequest{
    assertCode:string;
    constructor(assertCode:string){
            this.assertCode = assertCode;
    }
}